import Component from 'gia/Component';

import { gsap } from "gsap";

import { TextPlugin } from "gsap/TextPlugin";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
export default class Block extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      images: []
    }
    this.options = {
      bottom: false
    }
  }

  mount() {
    console.log(this.options);
    gsap.to(this.element, {
      x: 0,
      y: 0,
      opacity: 1,
      scrollTrigger: {
        trigger: this.element,
        start: this.options.bottom ? "top bottom" : "top center"
      }
    })

    // let timeline = gsap.timeline({
    //   scrollTrigger: {
    //     trigger: 'body',
    //     scrub:1,
    //     start: "top top"
    //   }
    // });
    //
    // this.ref.images.forEach((image, index) => {
    //   timeline.to(image, {
    //     'opacity': '100%',
    //     duration:0.1
    //   });
    // });

  }


}